import { UnitEconomics } from '../../../models/profit/profit.model';
import { useGet } from '../../useApi';

// GET /admin/profit/unit-economics
const useUnitEconomics = () => {
  const { data, loading, fetch } = useGet<UnitEconomics>('Failed to load unit economics');
  return { economics: data, loading, fetchEconomics: () => fetch('api/v1/admin/profit/unit-economics') };
};

export default useUnitEconomics;
